export default __webpack_public_path__ + "static/media/proof.0984a27e.png";